// Stable string hash so a word keeps its palette color and orientation
// across re-sorts and re-layouts.
export const hashText = (text) => {
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) - hash + text.charCodeAt(i)) | 0; // eslint-disable-line no-bitwise
  }
  return Math.abs(hash);
};

export const lightenColor = (color, mixWithWhite) => {
  if (typeof color !== 'string') return { r: 255, g: 255, b: 255 };
  let hex = color.replace('#', '');
  if (hex.length === 3) hex = hex.split('').map((ch) => ch + ch).join('');
  const num = parseInt(hex, 16);
  if (Number.isNaN(num) || hex.length !== 6) return { r: 255, g: 255, b: 255 };
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return {
    r: Math.round(r + (255 - r) * mixWithWhite),
    g: Math.round(g + (255 - g) * mixWithWhite),
    b: Math.round(b + (255 - b) * mixWithWhite)
  };
};

const SCATTERED_ANGLES = [-60, -30, 0, 30, 60, 90];

// Each style is a text arrangement (rotation + packing method), not a color
// scheme. Only 'chips' draws a background and needs rectangular collision;
// the rest use glyph-shaped collision for tight bare-text interlocking.
export const WORD_STYLE_CONFIG = {
  chips: { hasChip: true, useRectCollision: true, rotate: () => 0 },
  classic: { hasChip: false, useRectCollision: false, rotate: () => 0 },
  mixed: { hasChip: false, useRectCollision: false, rotate: (text) => (hashText(text) % 2) * 90 },
  scattered: { hasChip: false, useRectCollision: false, rotate: (text) => SCATTERED_ANGLES[hashText(text) % SCATTERED_ANGLES.length] }
};

// All three levels pack IDENTICALLY (same padding, same spiral) - this is
// deliberate. Font size is derived from how tightly words pack (see
// computeFill in useWordCloudLayout), so if packing varied by level the font
// would shrink as spread increased. Keeping the packing fixed keeps the font
// size identical across Compact/Normal/Spread.
//
// Only the render-time position stretch varies:
//  - axisFill: how far word POSITIONS push per-axis into the empty space
//    around the packed cloud (0 = leave the tight cluster centered - Compact).
//  - edgeMargin: how close to the container edge the outermost words land
//    (<1 leaves an inset gap - Normal; 1 = word edges touch the boundary -
//    Spread).
// Both only move positions apart without touching glyphs, so words spread to
// the edges without changing size, and moving apart can never cause overlap.
export const WORD_SPREAD_CONFIG = {
  compact: { paddingScale: 1, axisFill: 0, edgeMargin: 0.9, spiral: 'archimedean' },
  normal: { paddingScale: 1, axisFill: 1, edgeMargin: 0.82, spiral: 'archimedean' },
  spread: { paddingScale: 1, axisFill: 1, edgeMargin: 1, spiral: 'archimedean' }
};
